"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNativeDataTypesOfNormalizedType = exports.DATE_MATHS_OPERATORS = exports.NORMALIZED_DATA_TYPES = void 0;
const nativeDataTypeDatabase_1 = require("./nativeDataTypeDatabase");
__exportStar(require("./nativeDataTypeDatabase"), exports);
__exportStar(require("./types"), exports);
exports.NORMALIZED_DATA_TYPES = [
    "number",
    "boolean",
    "string",
    "date_time",
    "string[]",
];
exports.DATE_MATHS_OPERATORS = [
    "seconds_between",
    "minutes_between",
    "hours_between",
    "days_between",
];
const getNativeDataTypesOfNormalizedType = (client, normalizedDataType) => {
    const allTypes = Object.keys(nativeDataTypeDatabase_1.NATIVE_DATA_TYPES_DATABASE[client]);
    // Only keep native data types that are of the normalized data type.
    return allTypes.filter((nativeDataType) => {
        return (nativeDataTypeDatabase_1.NATIVE_DATA_TYPES_DATABASE[client][nativeDataType].normalizedType ===
            normalizedDataType);
    });
};
exports.getNativeDataTypesOfNormalizedType = getNativeDataTypesOfNormalizedType;
